var MDB = window.MDB || {};

(function(){
	var _isInitialized;

	function assignDataSource(config, selector){
		var dataSourceUrl = selector.data('dataSourceUrl');

		if(dataSourceUrl){
			config.dataTextField = 'Text';
			config.dataValueField = 'Value';

			config.dataSource = new kendo.data.DataSource({
				transport: {
					read: {
						url: dataSourceUrl
					}
				}
			});
		}
		var value = selector.data('value');

		if(value) {
			config.value = value;
		}

		return config;
	}

	function convertToCollapsable(selector) {
		var widget =  selector.parents('.k-widget');
		var wrapper = widget.find('.k-multiselect-wrap.k-floatwrap');
		wrapper.addClass('collapsed');

		selector.data('kendoMultiSelect').bind('open', function () {
			wrapper.removeClass('collapsed');
		});

		wrapper.click(function() {
			wrapper.removeClass('collapsed');
		});	

		selector.blur(function() {
			wrapper.addClass('collapsed');
			wrapper[0].scrollTop = 0;
		});
	}

	function addValidation() {
		$('#new-campaign').find('form').data("validator").settings.ignore = ":hidden:not(#Titles)";
	}

	$.extend(MDB, {
		initKendoMultiSelects: function (selector) {
			selector = $(selector);
			
			selector.find('[data-type="multiselect"]').each(function () {
		    	
		    	var me = $(this);
		    	var collapse = me.data('collapse') === 'True';

				if(!me.data('kendoMultiSelect')) {
					var config = getConfig(me, collapse);
				
					if(me.data('editable') === 'True') {
						MDB.KendoConfigBuilder.extendablebleMultiDropdown(me, config, 250);
					} else {
						me.kendoMultiSelect(config);
					}

					// var ignore = me.closest('form').data('validator').settings.ignore;
					
					// var replace = ignore.replace(/(:hidden)(:not)*(\(?(.*)\))?/g, function (a,b,c,d,e) {
					// 	// a = full match
					// 	// b = :hidden
					// 	// c = :not
					// 	// d = (<values>)
					// 	// e = <values>

					// 	if(c === undefined) {
					// 		return `${a}:not(#${me.prop('id')})`;
					// 	} else {
					// 		if(e.match(`#${me.prop('id')}`)) {
					// 			return a;
					// 		} else {
					// 			return `${b}${c}(${e},#${me.prop('id')})`;
					// 		}
					// 	}
					// });

					// me.closest('form').data('validator').settings.ignore = replace;
				}

				if(collapse) {
					convertToCollapsable(me);
				}

			});
		},
		bootKendoMultiSelects: function () {
			if(_isInitialized) {
				return;
			}
			
			_isInitialized = true;
			MDB.initKendoMultiSelects($('body'));
		}
	});


	function getConfig(selector, collapse) {
    	var config = selector.data('config');
    	
    	config = config ? config : {};
    	config.autoClose = false;

    	//Annoyingly. clicking the delete button on an item does not focus the input.
    	//We're fixing that here. (focussed collapsable multiselects get expanded. So we can see all the items.)
    	if(collapse) {
    		config.change = function (e) {
	           
	            var previous = this._savedOld;
	            var current = this.value();
	            
	            var diff = [];
	            
	            if (previous) {
	              diff = $(previous).not(current).get();
	            }

	            this._savedOld = current.slice(0);
	            
	            if(diff.length > 0){
	              this.focus();
	            }
          	};
    	}

		return assignDataSource(config, selector);
	}

	$(document).ready(function() {
	   MDB.initKendoMultiSelects($('body'));
	});
}());